import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import {
	ToothFracturePosition,
	ToothFractureType,
	ToothSurface,
} from '../../../../../graphql/graphql';

export const Tooth47: ToothDataEntry = {
	[ToothView.LINGUAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M36.3,350.3c104.4-30,141.8-12.5,141.8-12.5l20.3,49.6,5.3,15.5,2.8,13.4,1.2,11-2.9,16.6-4.3,9.2-7.6,7.6-11.3,5.5-22.3,2.3-16.3-.2-18.3-4.7-33.5,6.5-16,3.6-17-3.8-10.9-9-8.9-12.3-5.1-12.9-2.7-9.5-1.2-13.4-.9-15.1,1.4-20.1,4.2-21,2.2-6.4h0Z',
			},
			[ToothSurface.Lingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M129.9,370.5a18.3,18.3 0 1,1 -36.6,0a18.3,18.3 0 1,1 36.6,0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M154.6,356.2c-11.2,2.6-7.2,15.7-7.2,15.7l13.3,95.7s3.6.7,13.5-.9c41.4-6.6,31.5-44.2,31.9-50.6.4-6.8-23.5-63.2-23.5-63.2,0,0-16.8.7-28,3.3Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M31.8,368.8h0s21.4-1.2,32.5-2.1c11.1-1,11.6,11.4,11.6,11.4l12.8,92.3-13.2,1.8s-14.3.9-19.5-4c-38.3-23-24.2-99.5-24.2-99.5h0Z',
			},
			[ToothSurface.DistoLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M33.2,357l2-6.6s37.2-11,65.7-14.5c0,0-8.6,77.6,6.8,85.9,21,11.2,14.8,41.9,14.8,41.9l-48.1,8.7s-12.7.4-19.1-4.5c-48.1-36.9-22-111-22-111h-.1Z',
			},
			[ToothSurface.MesioLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M179.6,340.7l-1.4-3s-19.8-9.4-77.1-2c0,0-8.4,78.5,6.8,85.9,21.1,11.4,14.8,41.9,14.8,41.9,0,0,27.6,7.7,51.5,3.1,41.2-7.7,31.5-44.2,31.9-50.6.5-6.7-26.6-75.3-26.6-75.3h0Z',
			},
			[ToothSurface.CervicalLingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M175.6,329.4l-2-7.1c-61-6.4-134.6,14.9-134.6,14.9l-2.7,13c102.7-29.6,141.8-12.5,141.8-12.5,0,0-2.5-8.3-2.5-8.3Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'32 427.5 45.3 398.7 59.1 434.2 64.2 387.9 85.8 431.6 93 383.8 114.9 426.9 122.6 379.6 145.1 425.5 151.2 377.9 174.3 421.3 173.9 382.2 198.6 402.7',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'65.6 344.4 76.5 334.7 60.6 329.3 71.6 319.5 56.9 314.4 67.3 305.1 54.1 300.6 64.2 291.6 49.1 286.4 59 277.7 46.9 273.6 56.9 264.8 43.6 260.3 54.1 250.9 41.7 246.8 52.2 237.4 40.5 233.3 50.8 224.3 36.7 219.5 48.7 208.9 35.1 204.1 46.9 193.7 32.8 188.8 44.5 178.6 28.6 173 39.3 163.5 24.4 158.3 37.2 147.2 23.1 142.3 34.6 132.1 19.7 127 31.9 116.2 17.2 111.1 28.9 97.5 13.2 95.9 23.5 78.8',
				'88 75 105.5 84.8 102.2 97.2 118.7 97.1 113.8 111.1 127.1 114.2 115.5 127.1 129.4 133.7 117.2 142.3 132.6 149.5 119.8 158.6 132.6 164.7 118.9 174.5 133 181.1 120.8 189.7 135.1 196.4 123.4 204.8 137.9 211.6 125.7 220.2 138.1 226 128 233.2 140.6 239.2 129.9 246.7 142.6 252.7 131.1 260.7 143.1 266.4 132.6 273.7 144.6 279.3 131.5 288.6 143.7 294.4 132.3 302.4 144.9 308.4 132.2 317.4 145.4 323.7 131.7 333.4 144.9 339.6',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'168 214.1 149.2 199 136.2 219 114.8 202.2 98.5 224.3 79.8 206.3 64.7 225.7 48.1 213.3 38.2 230.7 24.1 215 16.4 232.9',
			],
		},
	},
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '147 183.6 123.4 188.1 105 187.3 77.5 182.5 67.7 178.9 53.6 171.5 39.5 162.4 29.5 147.4 23.9 111.9 23.1 100.4 34.2 49.1 42.7 34.8 59.7 23.1 94.3 17.7 118.1 22 150.2 35.5 167.8 37.9 183 43.6 198.4 53.1 207.6 65.6 210.8 82.3 210.7 95.1 205.4 130.1 200.2 147.2 187.1 161.5 147 183.6',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M169.4,84l39.5-13.3,2.2,10-.6,10.3-.6,12.3-5.1,29.6-4.3,14.7-6.8,6-33.9-31.8s.9,1-12.4-12.4c-13.3-13.4,3.1-19,3.1-19l18.8-6.4h.1Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M39.9,41.4l-2.5,3-3.3,6.9-3.8,11.3-6.4,37.3s-1.7,35.4,6.4,43.7l30.9-33.3,10.6-11.5c12-9.7.8-18.7.8-18.7l-8.6-10-24.1-28.6h0Z',
			},
			[ToothSurface.DistoBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M61.3,110.3l-30.9,33.3-.4,5.6,9.4,13.3,5,2.1,4.8,4.1,7.9,5.3,7.7,3.7,14.3,5.1s16.9-37.8,15.9-54.5c-1-16.8-1.6-19-5.5-21.8s-28.2,3.8-28.2,3.8h0Z',
			},
			[ToothSurface.MesioBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M193.7,153.4l-6.5,7.9-8.8,5.5-31.3,16.7-22.7,4-19.3-.3-26.1-4.3c6.4-14.6,15.9-36.8,15.9-54.5-.7-19.6-5.5-21.8-5.3-21.8,6.3,2.5,8,28.9,27.8,17.1,19.7-11.8,42.4-1.9,42.4-1.9l33.9,31.8v-.2Z',
			},
			[ToothSurface.MesioLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M208.6,70.9h0l-39.5,13.3c-33.7,10.4-33.5-10.7-54.4-12.9,0,0,9.5-11.3,8.2-20.4,2-7.9,9.2-22,9.2-22l17.1,6.3,18.5,2.8,15.9,6.2,14.5,8.9,7.2,10,3.4,7.5v.3Z',
			},
			[ToothSurface.DistoLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M132.3,28.5h0c-7.5,16-9.1,22.1-9.1,22.1.8,5.7-1.4,11.6-8.2,20.4,0,0-13.4-1.2-20.2,2.9s-10.8,3.4-14.9,2.2-15.8-6.1-15.8-6.1l-24.1-28.6,2.8-6.7,6.1-4.2,5.2-2.9,5.7-4.6,8.2-1,9-1.8,9.8-.9,7.5-1.6,23.8,4.3,14,6.8.2-.3Z',
			},
			[ToothSurface.Occlusal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M161,86.2l8.2-2.1s-6.4,2.1-13.3,4.6c-10.8,3.9-19.8,8.8-8.7,20.6,3.1,3.1,12.4,12.6,12.4,12.6,0,0-19-8.8-42.4,1.9-1.9,1.2-10.8,7.5-18.3-1.9-2.8-3.6-7.8-15.2-9.5-15.2-6.3-2.3-28.2,3.8-28.2,3.8l10.6-11.5c14.6-12.7-8.3-24.9-7.9-28.8l15.8,6.1c5.6,1.8,9,1.2,14.9-2.2s14.7-3.2,20.2-2.9c16.8.8,21.8,19.6,46.2,14.9h0Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Vertical}`]: [
				'29.2 76 41.7 107.4 58.7 70.6 61.2 120.4 86.9 74.9 91.7 126.5 117.7 81.8 123.3 132.9 149.8 85.1 153.5 136.3 180.8 91.3 178.1 133 205.6 112.7',
			],
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M174.6,182.7s-69.3,28.4-148.9-12.1l-2.4-7.6-1.9-6.6-3.4-14-2.2-17.1-.8-15.1-.2-11.1.9-13.9,2-14.7,1.3-5.7,1.9-6.8,4.8-6.6,7.1-2.4,16.2,2.9,9.1-3.2,3.5-.5,4.5-2.4,22.7-8.2,44.2,3.4,19.9-2.1,17.2,6,18,10.4,3.5-.4h5s4.5.9,4.5.9l2.8,1.8,1.3,2.8,2.4,6.6.9,6.9.4,9.7-1.3,9.4-3.8,14.6-24.6,56.8-4.7,18.3h0Z',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M119.1,140.8a17.9,17.9 0 1,1 -35.8,0a17.9,17.9 0 1,1 35.8,0Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M74,43.5h0s-8.7,82.9-15.2,109.5c-.9,6.6-6.3,10.3-12.8,9.4l-23.6-2.1-4.1-18-1.6-9.3-1.5-19.2.8-20.1,1-19.1,3.1-13.9,4.4-7.5,9.2-4.1,11.5,2.5,7.6,1,21.1-9.3v.2Z',
			},
			[ToothSurface.MesioBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M174.4,182.5s-27.6,11.6-68.1,9.3c-14.6-27.6,30-116.1,25.6-150.3l20.6-2.2,7.4,2.3,9.3,4.4,8.4,3.9,10.4,5.6,6.7-.3,5.7,1.4h0l3.2,1.6,3,4.3,1.2,6.3.8,6.6-.4,8.8-2.2,15.4-26.1,57.9-3.8,13.9-1.6,11.3v-.2Z',
			},
			[ToothSurface.DistoBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M106.5,192.1s-39.4,0-80.8-21.4l-3.3-10.5-4.1-18-1.6-9.3-1.5-19.2.8-20.1,1-19.1,3.1-13.9,4.4-7.5,9.2-4.1,11.5,2.5,7.6,1,34-14.7h0l17.3,1.2,27.9,2.6c5.2,34.1-39,116.9-25.6,150.4h.1Z',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M174.6,182.7l-2.5,15.4c-91.9,25.6-144.2-13.1-144.2-13.1l-2.3-14.4c80.3,40.1,148.9,12.1,148.9,12.1h0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M175.8,174.7l25.4-60.5,4.8-14.6,2.2-15.4.4-8.8-.8-6.6-1.2-6.3-3-4.3-3.1-1.5-5.7-1.4-6.7.3-15.2-9.7-19.7-6.4s-14.6,110-15.8,118.9c-1,7.7,3.4,12.5,9.9,13.4s28.6,3,28.6,3h-.1Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'16.2 85.6 31.3 117.9 46.5 77.8 52 129.9 75.6 80.4 83.7 134.3 107.9 85.5 116.6 138.9 141.3 86.8 147.9 140.5 173.5 91.2 173.2 135.4 200.1 112.2',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'26.6 425 14.9 411.6 29.4 406.5 17.4 395.9 32.1 390.8 20.7 380.8 34.6 375.9 21.9 364.9 36.6 359.7 26 350.3 41.7 344.8 30.1 334.7 44.1 329.8 32.3 319.6 45.7 314.8 33.8 304.4 47.7 299.5 37.6 290.7 49.1 286.6 38.7 277.4 50.9 273.2 40.5 264 53.6 259.5 43.8 250.9 55.7 246.7 45.9 238.2 60.8 233 50.8 224.1 63.8 219.6 53.5 210.4 68 205.3 57.1 195.8 72.8 190.3 62 180.8',
				'140.4 185.2 127.4 191.4 141 201 127.9 207.2 140.5 216.1 128.1 222.1 139.4 230 127.3 235.8 140.3 244.8 128.5 250.4 138.9 257.6 127 263.3 138.4 271.2 125.9 277.2 136.5 284.5 124 290.5 134 297.6 121.8 303.4 133.9 311.8 119.6 318.6 131.2 326.9 117.1 333.6 129.2 342 115.3 348.6 128.9 358.2 116.2 364.3 128.9 373.3 113.7 380.4 125.8 388.9 107.4 393.4 116.3 405.1 100.6 406.8 102.4 418.6 89.3 416.8 84.6 428.6',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'9.6 294.8 17.4 312.5 31.2 296.9 41.1 314.1 57.5 301.8 72.4 320.9 90.8 303 107 324.9 128.1 308.2 141.2 327.9 159.6 312.9',
			],
		},
	},
};
